import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Link } from 'react-router-dom';
import { KC_NAVIGATOR_PATH, KC_TOOLS_PATH } from '../repository';
import { KC_COLORS } from '../theme';

export function GuidesNavigatorCallout() {
  return (
    <div
      className="mb-5 flex flex-col gap-3 rounded-xl border px-4 py-3.5 sm:flex-row sm:items-center sm:justify-between"
      style={{
        borderColor: 'rgba(0,155,170,0.28)',
        background:
          'linear-gradient(90deg, rgba(230,247,246,0.95) 0%, #FFFFFF 70%)',
      }}
    >
      <div className="flex min-w-0 items-start gap-3">
        <span
          className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white"
          style={{ backgroundColor: KC_COLORS.teal }}
        >
          <ExploreOutlinedIcon sx={{ fontSize: 18 }} />
        </span>
        <div className="min-w-0">
          <p
            className="m-0 font-bold"
            style={{ color: KC_COLORS.primaryNavy, fontSize: '14px', lineHeight: '20px' }}
          >
            Looking for implementation centers or practical tools?
          </p>
          <p
            className="m-0 mt-0.5"
            style={{ color: KC_COLORS.gray600, fontSize: '13px', lineHeight: '18px' }}
          >
            Use the Navigator to find the right package by role, objective, and stage of AI adoption.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 sm:shrink-0">
        <Link
          to={KC_NAVIGATOR_PATH}
          className="inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-[13px] font-semibold no-underline"
          style={{ backgroundColor: KC_COLORS.teal, color: '#fff' }}
        >
          Open Navigator
          <ArrowForwardRoundedIcon sx={{ fontSize: 14 }} />
        </Link>
        <Link
          to={KC_TOOLS_PATH}
          className="inline-flex items-center gap-1 rounded-lg border px-3 py-1.5 text-[13px] font-semibold no-underline"
          style={{ borderColor: KC_COLORS.teal, color: KC_COLORS.primaryNavy }}
        >
          Tools
        </Link>
      </div>
    </div>
  );
}
